import { render, staticRenderFns } from "./GroupView.vue?vue&type=template&id=ea98f9f8"
import script from "./GroupView.vue?vue&type=script&lang=js"
export * from "./GroupView.vue?vue&type=script&lang=js"
import style0 from "./GroupView.vue?vue&type=style&index=0&id=ea98f9f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports